import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'

import { router } from './app/router'
import { ApiException } from './api/client'
import { primeTheme } from './theme/prime'
import { instalarInformeDeErrores } from './lib/erroresDelNavegador'
import { FronteraDeError } from './app/FronteraDeError'
import './index.css'

/*
 * Antes de montar React, no después.
 *
 * En el dominio de un estudio, el primer pintado con nuestros colores por
 * defecto enseña la marca equivocada hasta que responde `/tenant/branding`.
 * Esto aplica lo que ya se sabe de este host —o un neutro, si es la primera
 * visita— para que ese instante no sea azul.
 */
primeTheme()

/*
 * Y antes de montar también, para que cubra lo que pase DURANTE el montaje.
 * Enganchado aquí y no dentro de un componente porque un error en el árbol de
 * React puede impedir que ese componente llegue a montarse — que es justo el
 * caso que más falta hace contar.
 */
instalarInformeDeErrores()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Con RTT Lima↔US East de ~55–90 ms, reconsultar al enfocar la ventana
      // es latencia gratuita sin información nueva.
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      retry: (failureCount, error) => {
        // No reintentar errores del cliente: un 403 no mejora insistiendo.
        if (error instanceof ApiException && error.status < 500) return false
        return failureCount < 2
      },
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* Por FUERA del router: coge lo que revienta antes de que haya ruta
          —los proveedores, el primer render— y que el `errorElement` no puede
          ver. Sin esto, ese caso sigue dando pantalla en blanco. */}
      <FronteraDeError>
        <RouterProvider router={router} />
      </FronteraDeError>
    </QueryClientProvider>
  </StrictMode>,
)
